export abstract class CacheService {
    abstract getItemCommunicator<T>(): Promise<T>
    abstract setItemCommunicator(params?: object): Promise<void>;
    abstract deleteItemCommunicator(): Promise<void>;
}
